import { base62 } from './encoding/BaseX';
import { shortenedHashOf } from './shortenedHashOf';

export const shortenedHashBase62 = (input: string) => {
  const hashedPathname = shortenedHashOf(input);
  return base62.encodeUtf8(hashedPathname);
};
